import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How life sucks the fun out of all",
  "description": "",
  "published": "2008-07-11T00:00:00.000Z",
  "redirect_from": ["/blog/how-life-sucks-the-fun-out-of-all/swizec/95"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Some of you might remember how `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=294"
      }}>{`Lestat died`}</a>{` a while ago, six months' worth of a while ago apparently, and I've been reluctant to fix him because everything was so dated there was simply no point in patching it up. So I waited until Sunday when I could order all new bits, a fancy new motherboard, CPU, graphics card, RAM and even a speedy hard drive.`}</p>
    <p>{`On wednesday all the parts arrived and in the evening I completely and totally neglected my girlfriend putting it all together. First I stripped out the old parts and yadayada, most of all I decided to do it nice and slow and to take great pleasure in it. Because hell, what greater pleasure is there for a geek than setting up a whole new computer from scratch, I'd've been up all night but for one thing. ... It didn't work.`}</p>
    <p>{`When I turned it on, suspense built up and then nothing happened. The fans were blasting, the front panel lights all burned and ... nothing else happened. The cause? Either a brand new CPU failure or a brand new motherboard failure. My bet was on CPU so yesterday I went to the store and asked for a new one, but the clerk, seemingly somewhat knowledgable, looked at it and said at least three pins didn't settle so I should bring the motherboard in as well because perhaps the problem was there. So I did.`}</p>
    <p>{`Thinking that we'd just do a quick check and they'll give me my parts was a mistake, a stupid one I admit. The computer had to be left there to be looked over by their maintenance staff and it'd take at least a day, perhaps more, seeing as how it's the weekend I'll probably only get it next month. Fucking shit.`}</p>
    <p>{`But after all of these shenanigans I am simply not enthusiastic about the computer anymore. It'll be put together by a third party, somebody will've messed inside my computer that hasn't been touched by anybody other than me in seven years. I feel somewhat violated, raped even. That's `}<em parentName="p">{`my`}</em>{` computer and now somebody else is going to poke around in it! That's just `}<strong parentName="p">{`wrong`}</strong>{`.`}</p>
    <p>{`If it comes back with windows installed, or the data on my old hdd is touched, I'm suing them ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      